// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1s8f-","list":"styles_list__1pJGv"};